import { RightOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import { useHistory } from 'react-router-dom';
import MenuSidebarAndContainer from '../../../components/MenuSidebarAndContainer/menu-sidebar-and-container.component';
import BaseInput from '../components/base-input';
import BaseSelect from '../components/base-select';
import HeaderContainer from '../components/header';
import { widthEnum } from '../types/tamanho-enum';
import Styles from './fornecedor.module.scss';
import useSaveAndFetchDataFornecedor from './hooks/use-save-and-fetch-data';
import useEnderecoHook from './hooks/use-endereco';
import useInputHook from './hooks/use-input-hook';
import { formatLandlinePhone, formatPhone } from '../../../util/format';

export default function FornecedorCreate() {
	const { fornecedor, tipoPapel, indicadorInscricaoEstadual, handleSaveOrEdit, setFornecedor } = useSaveAndFetchDataFornecedor();
	const { pais, onCepChange } = useEnderecoHook(fornecedor, setFornecedor);
	const { verifyMaxLength, formatarCpfCnpj } = useInputHook();
	const history = useHistory();
	return (
		<MenuSidebarAndContainer itemMenuSelected={14}>
			<HeaderContainer>
				<div className={Styles.header}>
					<h3 className={Styles.title} style={{ cursor: 'pointer' }} onClick={() => history.push('/contas-a-pagar')}>
						Contas a Pagar
					</h3>
					<h3 className={Styles.title}>
						<RightOutlined style={{ margin: '0 3px' }} size={16} rev={undefined} />
						Novo Fornecedor
					</h3>
				</div>
			</HeaderContainer>
			<div className={Styles.container_lancamento}>
				<span className={Styles.titulo_lancamento}>INFORMAÇÕES DO LANÇAMENTO</span>
				<div className={Styles.input_list}>
					<div className={Styles.container_input}>
						<BaseSelect
							showSearch
							filterOption={(input, option) => option.props.title.toLowerCase().includes(input.toLowerCase())}
							value={fornecedor?.tipoPessoa}
							width={widthEnum.lg}
							placeholder="Selecione o tipo de pessoa"
							labelConfig={{
								label: 'Tipo de pessoa',
								required: true,
								tooltip: true,
								tooltipText: 'Selecione se o fornecedor é pessoa física ou jurídica.',
							}}
							onChange={(e) => {
								setFornecedor(() => {
									const newForncedor = { ...fornecedor };
									newForncedor.tipoPessoa = e;
									newForncedor.documento = '';
									return newForncedor;
								});
							}}
						>
							<Select.Option title='fisica' value="Física">Física</Select.Option>
							<Select.Option title='juridica' value="Jurídica">Juridica</Select.Option>
						</BaseSelect>
						<BaseInput
							maxLength={verifyMaxLength(fornecedor?.tipoPessoa)}
							max={verifyMaxLength(fornecedor?.tipoPessoa)}
							onChange={(e) => {
								const valorDigitado = e.target.value;
								const documentoFormatado = formatarCpfCnpj(valorDigitado);

								setFornecedor({ ...fornecedor, documento: documentoFormatado });
							}}
							value={fornecedor?.documento}
							labelConfig={{ label: 'CNPJ/CPF', required: true }}
							placeholder={fornecedor?.tipoPessoa === 'Física' ? 'Digite seu CPF' : 'Digite seu CNPJ'}
						/>
						<BaseInput
							max={100}
							maxLength={100}
							value={fornecedor?.nomeFantasia}
							width={widthEnum.lg}
							onChange={(e) => setFornecedor({ ...fornecedor, nomeFantasia: e.target.value })}
							labelConfig={{
								label: 'Nome fantasia',
								required: true,
								tooltip: true,
								tooltipText: 'Nome comercial usado pelo fornecedor.',
							}}
							placeholder="Digite seu nome fantasia"
						/>

						<BaseSelect
							showSearch
							filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
							onChange={(e) => setFornecedor({ ...fornecedor, tipoPapel: { ...fornecedor.tipoPapel, id: e } })}
							value={fornecedor?.tipoPapel?.id}
							width={widthEnum.lg}
							placeholder="Selecione o tipo de papel"
							labelConfig={{
								label: 'Tipo de papel',
								required: true,
								tooltip: true,
								tooltipText: 'Escolha o papel do fornecedor (ex: fornecedor, cliente ou transportadora).',
							}}
						>
							{tipoPapel?.map((tp) => (
								<Select.Option key={tp.id} value={tp.id}>
									{tp.descricao}
								</Select.Option>
							))}
						</BaseSelect>
					</div>
				</div>
			</div>

			<div className={Styles.container_lancamento}>
				<span className={Styles.titulo_lancamento}>ENDEREÇO</span>
				<div className={Styles.input_list}>
					<div className={Styles.container_input}>
						<BaseInput
							maxLength={8}
							onChange={(e) => onCepChange(e.target.value)}
							value={fornecedor?.endereco?.cep}
							width={widthEnum.lg}
							labelConfig={{ label: 'CEP', tooltip: true, tooltipText: 'O endereço será preenchido automaticamente com o CEP' }}
							placeholder="CEP"
						/>
						<BaseSelect
							showSearch
							filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
							value={fornecedor?.endereco?.paisId}
							width={widthEnum.lg}
							placeholder="Selecione um país"
							labelConfig={{
								label: 'País',
							}}
							onChange={(e) =>
								setFornecedor({
									...fornecedor,
									endereco: { ...fornecedor.endereco, paisId: e },
								})
							}
						>
							{pais?.map((p) => (
								<Select.Option key={p.id} value={p.id}>
									{p.nome}
								</Select.Option>
							))}
						</BaseSelect>

						<BaseInput
							value={fornecedor?.endereco?.logradouro}
							width={widthEnum.lg}
							labelConfig={{ label: 'Endereço' }}
							placeholder="Digite seu endereco"
							onChange={(e) =>
								setFornecedor({
									...fornecedor,
									endereco: { ...fornecedor.endereco, logradouro: e.target.value },
								})
							}
						/>

						<BaseInput
							value={fornecedor?.endereco?.numero}
							width={widthEnum.md}
							labelConfig={{ label: 'Número' }}
							placeholder="123"
							onChange={(e) =>
								setFornecedor({
									...fornecedor,
									endereco: { ...fornecedor.endereco, numero: e.target.value },
								})
							}
						/>
					</div>
					<div className={Styles.container_input}>
						<BaseInput
							value={fornecedor?.endereco?.nomeUF}
							width={widthEnum.lg}
							labelConfig={{ label: 'Estado' }}
							placeholder="Bahia"
							onChange={(e) =>
								setFornecedor({
									...fornecedor,
									endereco: { ...fornecedor.endereco, nomeUF: e.target.value },
								})
							}
						/>

						<BaseInput
							value={fornecedor?.endereco?.cidade}
							width={widthEnum.lg}
							labelConfig={{ label: 'Cidade' }}
							placeholder="Salvador"
							onChange={(e) =>
								setFornecedor({
									...fornecedor,
									endereco: { ...fornecedor.endereco, cidade: e.target.value },
								})
							}
						/>

						<BaseInput
							value={fornecedor?.endereco?.bairro}
							width={widthEnum.lg}
							labelConfig={{ label: 'Bairro' }}
							placeholder="Centro"
							onChange={(e) =>
								setFornecedor({
									...fornecedor,
									endereco: { ...fornecedor.endereco, bairro: e.target.value },
								})
							}
						/>
						<BaseInput
							onChange={(e) => setFornecedor({ ...fornecedor, endereco: { ...fornecedor.endereco, complemento: e.target.value } })}
							value={fornecedor?.endereco?.complemento}
							width={widthEnum.md}
							labelConfig={{ label: 'Complemento' }}
							placeholder=""
						/>
					</div>
				</div>
			</div>

			<div className={Styles.container_section_duplo}>
				<div className={Styles.card_section}>
					<span className={Styles.titulo_lancamento}>CONTATOS</span>
					<div className={Styles.card_body_flex}>
						<div className={Styles.input_item_half}>
							<BaseInput
								max={100}
								maxLength={100}
								onChange={(e) => setFornecedor({ ...fornecedor, emailProfissional: e.target.value })}
								value={fornecedor?.emailProfissional}
								labelConfig={{ label: 'E-mail profissional' }}
								placeholder="email@email.com"
							/>
						</div>
						<div className={Styles.input_item_half}>
							<BaseInput
								max={100}
								maxLength={100}
								onChange={(e) => setFornecedor({ ...fornecedor, emailPessoal: e.target.value })}
								value={fornecedor?.emailPessoal}
								labelConfig={{ label: 'E-mail pessoal' }}
								placeholder="email@email.com"
							/>
						</div>
						<div className={Styles.input_item_half}>
							<BaseInput
								onChange={(e) => setFornecedor({ ...fornecedor, telefoneComercial: formatLandlinePhone(e.target.value) })}
								value={fornecedor?.telefoneComercial}
								labelConfig={{ label: 'Telefone comercial' }}
								placeholder="(00) 0000-0000"
								max={20}
								maxLength={20}
							/>
						</div>
						<div className={Styles.input_item_half}>
							<BaseInput
								onChange={(e) => setFornecedor({ ...fornecedor, telefoneCelular: formatPhone(e.target.value) })}
								value={fornecedor?.telefoneCelular}
								labelConfig={{ label: 'Telefone celular' }}
								placeholder="(00) 90000-0000"
								max={20}
								maxLength={20}
							/>
						</div>
					</div>
				</div>

				<div className={Styles.card_section}>
					<span className={Styles.titulo_lancamento}>DADOS FISCAIS</span>
					<div className={Styles.card_body_flex}>
						<div className={Styles.input_item_half}>
							<BaseInput
								max={20}
								maxLength={20}
								onChange={(e) => setFornecedor({ ...fornecedor, razaoSocial: e.target.value })}
								value={fornecedor?.razaoSocial}
								labelConfig={{ label: 'Razão social', tooltip: true, tooltipText: 'Informe o nome jurídico da empresa.' }}
								placeholder="Razão Social LTDA"
							/>
						</div>
						<div className={Styles.input_item_half}>
							<BaseSelect
								onChange={(e) => setFornecedor({ ...fornecedor, indicadorInscricaoEstadual: { ...fornecedor?.indicadorInscricaoEstadual, id: e } })}
								value={fornecedor?.indicadorInscricaoEstadual?.id}
								labelConfig={{
									label: 'Indicador de inscrição estadual',
									tooltip: true,
									tooltipText: 'Indica se a empresa é contribuinte de ICMS e se possui inscrição estadual.',
								}}
								placeholder="Selecione..."
								width="100%"
							>
								{indicadorInscricaoEstadual?.map((i) => (
									<Select.Option key={i.id} value={i.id}>
										{i.descricao}
									</Select.Option>
								))}
							</BaseSelect>
						</div>
						<div className={Styles.input_item_half}>
							<BaseInput
								max={20}
								maxLength={20}
								onChange={(e) => setFornecedor({ ...fornecedor, inscricaoEstadual: e.target.value })}
								value={fornecedor?.inscricaoEstadual}
								labelConfig={{
									label: 'Inscrição estadual',
									tooltip: true,
									tooltipText: 'Número de registro da empresa na Secretaria da Fazenda do Estado. Obrigatório para quem recolhe ICMS.',
								}}
								placeholder="Digite a inscrição estadual"
							/>
						</div>
						<div className={Styles.input_item_half}>
							<BaseInput
								max={20}
								maxLength={20}
								onChange={(e) => setFornecedor({ ...fornecedor, inscricaoMunicipal: e.target.value })}
								value={fornecedor?.inscricaoMunicipal}
								labelConfig={{
									label: 'Inscrição municipal',
									tooltip: true,
									tooltipText: 'Número de registro da empresa na Prefeitura. Obrigatório para prestadores de serviço que recolhem ISS.',
								}}
								placeholder="Digite a inscrição municipal"
							/>
						</div>
						<div className={Styles.input_item_full} style={{ display: 'flex', gap: '12px' }}>
							<input
								onChange={(e) => setFornecedor({ ...fornecedor, optanteSimples: e.target.checked })}
								checked={!!fornecedor?.optanteSimples}
								type="checkbox"
								id="simples"
							/>
							<label htmlFor="simples">Optante pelo Simples</label>
							<input
								onChange={(e) => setFornecedor({ ...fornecedor, orgaoPublico: e.target.checked })}
								checked={!!fornecedor?.orgaoPublico}
								type="checkbox"
								id="orgao-publico"
							/>
							<label htmlFor="orgao-publico">Orgão público</label>
						</div>
					</div>
				</div>
			</div>

			<div className={Styles.footerActions}>
				<button className={Styles.cancelBtn} onClick={() => history.push('/contas-a-pagar')}>
					Voltar
				</button>
				<button onClick={handleSaveOrEdit} className={Styles.saveBtn}>
					Salvar
				</button>
			</div>
		</MenuSidebarAndContainer>
	);
}
